const ENVIRONMENT = import.meta.env.VITE_ENVIRONMENT;

export const {
  IS_PROD, IS_STAGE, IS_DEV, IS_LOCAL,
} = {
  IS_PROD: ENVIRONMENT === 'prod',
  IS_STAGE: ENVIRONMENT === 'stage',
  IS_DEV: ENVIRONMENT === 'dev',
  IS_LOCAL: ENVIRONMENT === 'local',
};

export const ENVIRONMENTS = {
  API_URL: import.meta.env.VITE_API_URL,
  REOWN_PROJECT_ID: import.meta.env.VITE_REOWN_PROJECT_ID,
  REOWN_APP_NAME: import.meta.env.VITE_REOWN_APP_NAME,
};
